import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
Vue.use(require('vue-resource'))

Vue.locale('en', require('../../static/locale/en.json'))
Vue.locale('nl', require('../../static/locale/nl.json'))
Vue.locale('fr', require('../../static/locale/fr.json'))
Vue.locale('de', require('../../static/locale/de.json'))
Vue.locale('sk', require('../../static/locale/sk.json'))
Vue.locale('pl', require('../../static/locale/pl.json'))

var storage = window.localStorage.getItem('lang')
if (storage === null) {
  Vue.config.lang = 'en'
  window.localStorage.setItem('lang', Vue.config.lang)
} else {
  Vue.config.lang = storage
}



// WEBPACK FOOTER //
// ./src/translate/translate.js